import React from "react"

const CrossListItem = ({ children }) => (
  <div className="mt-4 flex space-x-3">
    <svg
      className="flex-shrink-0 h-6 w-6 text-red-500"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
        clipRule="evenodd"
      />
    </svg>
    <div className="space-y-2">
      <dt className="text-lg leading-6 text-gray-800">{children}</dt>
    </div>
  </div>
)

export default CrossListItem
